import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',[_vm._v("Admin Calderas")]),_c(VDivider)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }